import type { AxiosResponse } from 'axios'

/**
 * Yanlış `baseURL`/proxy (ör. boş string bir env değişkeninden gelirse) istekleri API'ye değil
 * uygulamanın kendi statik sunucusuna gönderir; SPA fallback bunu **200 + `index.html`** ile
 * yanıtlar — axios bunu "başarı" sanıp ham HTML string'ini `.data` olarak döndürür ve hata,
 * çağıran taraftaki bir `.map()`/`.filter()`'da anlamsız bir "is not a function" olarak patlar
 * (kaynağından çok uzakta, okunaksız bir minified iz'le). Bu koruma sorunu **kaynağında**, açık bir
 * mesajla yakalar (2026-08-15, rdc dev'de teşhisi saatler alan bir olaydan sonra eklendi).
 */
export function assertJsonResponse(response: AxiosResponse): void {
  const { data } = response
  if (typeof data === 'string' && /^\s*<(!doctype|html)/i.test(data)) {
    const { method, url, baseURL } = response.config
    const message =
      `API isteği JSON yerine HTML döndürdü — backend'e ulaşılamıyor olabilir (yanlış baseURL/proxy). ` +
      `${(method ?? 'GET').toUpperCase()} ${baseURL ?? ''}${url ?? ''} (HTTP ${response.status})`
    // Burada açıkça console.error: TanStack Query bu hatayı düzgün bir "handled rejection" olarak
    // yakalayıp ilgili ekranı zarifçe boş-durum'a düşürebiliyor (iyi UX) — ama tam da bu yüzden
    // tarayıcının kendi "uncaught exception" otomatik loglaması hiç tetiklenmiyor ve hata sessizce
    // kayboluyor (2026-08-15, rdc dev'de gözlemlendi: çökme düzeldi ama iz de kalmadı).
    console.error(message)
    throw new Error(message)
  }
}
